import { Description } from '@sparemin/blockhead';
import ThumbnailSkeleton from 'components/ThumbnailSkeleton';
import React from 'react';
import { useAudioPlayer } from '../../state';
import styles from './TrackInfo.module.scss';
import TrackSubtitle from './TrackSubtitle';
import TrackTitle from './TrackTitle';

export interface TrackInfoProps {}

const TrackInfo: React.FC<TrackInfoProps> = () => {
  const { thumbnailUrl: artworkUrl } = useAudioPlayer();

  return (
    <Description>
      <Description.Header>
        {artworkUrl ? (
          <Description.Thumbnail
            alt="track artwork"
            className={styles.thumbnail}
            ratio={1}
            src={artworkUrl}
          />
        ) : (
          <ThumbnailSkeleton className={styles.thumbnailSkeleton} />
        )}
        <Description.Headline>
          <TrackTitle />
          <TrackSubtitle />
        </Description.Headline>
      </Description.Header>
    </Description>
  );
};

export default TrackInfo;
